/* tslint:disable */
/* eslint-disable */
/**
 * API Shared Model
 * API Shared Model
 *
 * The version of the OpenAPI document: 1.121.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Enumerated type of Account verification state that indicates if the company account is verified
 * @export
 * @enum {string}
 */
export const AccountVerificationState = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    Undefined: 'UNDEFINED'
};
/**
 * Describes a binary boolean operator. DEPRECATED - Please use BooleanOperator instead
 * @export
 * @enum {string}
 */
export const BinaryBooleanOperator = {
    And: 'AND',
    Or: 'OR',
    Xor: 'XOR'
};
/**
 * Describes a binary filter operator. DEPRECATED - Please use FilterOperator instead
 * @export
 * @enum {string}
 */
export const BinaryFilterOperator = {
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE',
    Eq: 'EQ',
    Neq: 'NEQ',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    Before: 'BEFORE',
    NotBefore: 'NOT_BEFORE',
    After: 'AFTER',
    NotAfter: 'NOT_AFTER'
};
/**
 * Describes a binary boolean operator. Different operators may have different expected amounts of operands
 * @export
 * @enum {string}
 */
export const BooleanOperator = {
    And: 'AND',
    Or: 'OR',
    Xor: 'XOR',
    Not: 'NOT'
};
/**
 * Enumerated type of business type for which is the company used for
 * @export
 * @enum {string}
 */
export const BusinessType = {
    Other: 'LOB_OTHER',
    Construction: 'LOB_CONSTRUCTION',
    Emergency: 'LOB_EMERGENCY',
    Logistic: 'LOB_LOGISTIC',
    Manufacturing: 'LOB_MANUFACTURING',
    PeopleMover: 'LOB_PEOPLE_MOVER',
    Rental: 'LOB_RENTAL',
    ServiceWorkshop: 'LOB_SERVICE_WORKSHOP',
    TradeEgrocery: 'LOB_TRADE_EGROCERY'
};
/**
 * Brand types of a credit card
 * @export
 * @enum {string}
 */
export const CardOnFileAuthenticationStatusType = {
    NoAuth: 'NoAuth',
    Auth: 'Auth',
    Auth3ds1: 'Auth3ds1',
    Auth3ds2: 'Auth3ds2'
};
/**
 * Enumerated type of Account business verification state that indicates if the company account is verified by business commercial registration
 * @export
 * @enum {string}
 */
export const CommercialRegistrationState = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    Undefined: 'UNDEFINED'
};
/**
 * Enumerated type of Field usage for which is the field inside company used for
 * @export
 * @enum {string}
 */
export const CompanyFieldUsageType = {
    Mandatory: 'MANDATORY',
    Optional: 'OPTIONAL',
    Undefined: 'UNDEFINED'
};
/**
 * Enumerated type of consent state.
 * @export
 * @enum {string}
 */
export const ConsentState = {
    Undefined: 'UNDEFINED',
    Accepted: 'ACCEPTED',
    Revoked: 'REVOKED'
};
/**
 * Brand types of a credit card
 * @export
 * @enum {string}
 */
export const CreditCardBrandType = {
    Visa: 'visa',
    Mastercard: 'mastercard',
    Maestro: 'maestro',
    Jcb: 'jcb',
    Amex: 'amex',
    Diners: 'diners',
    Koreanlocal: 'koreanlocal',
    CarteBancaire: 'carte bancaire',
    Mir: 'mir',
    Rupay: 'rupay'
};
/**
 * Customer business type.
 * @export
 * @enum {string}
 */
export const CustomerBusinessType = {
    B2C: 'B2C',
    B2B: 'B2B'
};
export const CustomerTypeIdTypeEnum = {
    _1A: '1A',
    _2A: '2A',
    _2B: '2B',
    _2C: '2C',
    _3: '3'
};
/**
 * Enumerated type of a failure notification type
 * @export
 * @enum {string}
 */
export const FailureNotificationType = {
    Info: 'INFO',
    Warn: 'WARN',
    Error: 'ERROR'
};
/**
 * Enumerated type of field tooltip
 * @export
 * @enum {string}
 */
export const FieldTooltipType = {
    Info: 'INFO'
};
/**
 * Enumerated type of Field usage for which is the field inside company used for
 * @export
 * @enum {string}
 */
export const FieldUsageType = {
    Mandatory: 'MANDATORY',
    Optional: 'OPTIONAL',
    Undefined: 'UNDEFINED'
};
/**
 * Describes a filter operator. Different operators may have different expected amounts of operands
 * @export
 * @enum {string}
 */
export const FilterOperator = {
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE',
    Eq: 'EQ',
    Neq: 'NEQ',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    Before: 'BEFORE',
    NotBefore: 'NOT_BEFORE',
    After: 'AFTER',
    NotAfter: 'NOT_AFTER',
    IsNotNull: 'IS_NOT_NULL',
    IsNull: 'IS_NULL'
};
/**
 * Enumerated type of the supported filter types:   TEXT_SEARCH - allows to define an arbitrary (free-)text string   VALUE_LIST - allows to select one or more values from a pre-defined list of available values   DATE_RANGE - allows to specify an earliest/latest date (range) criteria   NUMERIC_RANGE - allows to specify a min/max numeric (range) criteria
 * @export
 * @enum {string}
 */
export const FilterOptionType = {
    TextSearch: 'TEXT_SEARCH',
    ValueList: 'VALUE_LIST',
    DateRange: 'DATE_RANGE',
    NumericRange: 'NUMERIC_RANGE'
};
/**
 * Type of transition applied to a given form sub-structure (e.g. `Positions` or `Field`) rendering state leading to a new/modified form sub-structure
 * @export
 * @enum {string}
 */
export const FormTransition = {
    VisibleTrue: 'VISIBLE_TRUE',
    VisibleFalse: 'VISIBLE_FALSE',
    MandatoryTrue: 'MANDATORY_TRUE',
    MandatoryFalse: 'MANDATORY_FALSE',
    MandatoryDefault: 'MANDATORY_DEFAULT',
    ModifiableTrue: 'MODIFIABLE_TRUE',
    ModifiableFalse: 'MODIFIABLE_FALSE',
    ModifiableDefault: 'MODIFIABLE_DEFAULT',
    SelectTrue: 'SELECT_TRUE',
    SelectFalse: 'SELECT_FALSE',
    Clear: 'CLEAR'
};
/**
 * Enumerated type of the invitation state.
 * @export
 * @enum {string}
 */
export const InvitationState = {
    Undefined: 'UNDEFINED',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    Pending: 'PENDING'
};
/**
 * Enumerated type of invoice address type
 * @export
 * @enum {string}
 */
export const InvoiceAddressType = {
    CompanyAddress: 'COMPANY_ADDRESS',
    CustomAddress: 'CUSTOM_ADDRESS'
};
/**
 *
 * @export
 * @enum {string}
 */
export const LengthType = {
    Kilometer: 'kilometer',
    Meter: 'meter',
    Centimeter: 'centimeter',
    Millimeter: 'millimeter',
    Foot: 'foot',
    Inch: 'inch',
    Yard: 'yard',
    Mile: 'mile'
};
/**
 * Enumerated type of notification
 * @export
 * @enum {string}
 */
export const NotificationType = {
    Info: 'INFO',
    Warn: 'WARN',
    Error: 'ERROR'
};
/**
 * Operation code for CUD actions
 * @export
 * @enum {string}
 */
export const Operation = {
    Create: 'create',
    Update: 'update',
    Delete: 'delete'
};
/**
 * Enumerated type of the permission mode
 * @export
 * @enum {string}
 */
export const PermissionMode = {
    Grant: 'GRANT',
    Deny: 'DENY'
};
/**
 * Enumerated position type of form position
 * @export
 * @enum {string}
 */
export const PositionType = {
    Checkbox: 'checkbox',
    Dropdown: 'dropdown',
    Group: 'group',
    Notification: 'notification',
    Placeholder: 'placeholder',
    RadioButton: 'radio_button',
    Text: 'text'
};
export const PositionsAlignmentEnum = {
    Horizontal: 'horizontal',
    Vertical: 'vertical'
};
/**
 * Enumerated type of the state for preferred contacts. The state UNASSIGNED means that a contact is assignable but not yet persisted. The ASSIGNED contacts are already assigned to a company or vehicle.
 * @export
 * @enum {string}
 */
export const PreferredContactState = {
    Unassigned: 'UNASSIGNED',
    Assigned: 'ASSIGNED'
};
/**
 * type of a `RoleConditionGroup` that defines how to build the boolean concatenation of multiple nested `RoleConditionMappings`
 * @export
 * @enum {string}
 */
export const RoleConditionGroupType = {
    And: 'AND',
    Or: 'OR',
    Not: 'NOT'
};
/**
 * Enumerated type of Rule engines that may be applied on client or server layer
 * @export
 * @enum {string}
 */
export const RuleEngineType = {
    BeSpel: 'BE_SPEL',
    FeJsonRule: 'FE_JSON-RULE'
};
/**
 * Sort order:   * `asc` - Ascending, from A to Z or 0-9   * `desc` - Descending, from Z to A or 0-9
 * @export
 * @enum {string}
 */
export const SortOperator = {
    Asc: 'ASC',
    Desc: 'DESC'
};
/**
 * Describes a unary boolean operator. DEPRECATED - Please use BooleanOperator instead
 * @export
 * @enum {string}
 */
export const UnaryBooleanOperator = {
    Not: 'NOT'
};
/**
 * Describes an unary filter operator. DEPRECATED - Please use FilterOperator instead
 * @export
 * @enum {string}
 */
export const UnaryFilterOperator = {
    NotNull: 'IS_NOT_NULL',
    Null: 'IS_NULL'
};
/**
 * Enumerated type of a vehicle authorization
 * @export
 * @enum {string}
 */
export const VehicleAuthorizationType = {
    Company: 'COMPANY',
    User: 'USER',
    UserChooser: 'USER_CHOOSER',
    Partner: 'PARTNER'
};
/**
 * Enumerated type of a notification category
 * @export
 * @enum {string}
 */
export const VehicleNotificationCategory = {
    UrgentAction: 'URGENT_ACTION',
    RetailAction: 'RETAIL_ACTION',
    FleetAction: 'FLEET_ACTION',
    PairingRequest: 'PAIRING_REQUEST',
    UnverifiedVehicle: 'UNVERIFIED_VEHICLE',
    ServiceA: 'SERVICE_A',
    ServiceB: 'SERVICE_B',
    GeneralInspection: 'GENERAL_INSPECTION'
};
/**
 * Enumerated type of a notification status
 * @export
 * @enum {string}
 */
export const VehicleNotificationStatus = {
    Reopened: 'REOPENED',
    New: 'NEW',
    Created: 'CREATED',
    InProgress: 'IN_PROGRESS',
    Sent: 'SENT',
    Delegated: 'DELEGATED'
};
/**
 * Options which define the input state of VehicleSalesDiscountScheme
 * @export
 * @enum {string}
 */
export const VehicleSalesDiscountSchemeOptionType = {
    None: 'NONE',
    NationalDiscountCode: 'NATIONAL_DISCOUNT_CODE',
    FleetSize: 'FLEET_SIZE',
    FleetSizeCount: 'FLEET_SIZE_COUNT',
    PurchaseCooperative: 'PURCHASE_COOPERATIVE',
    UniqueCustomerId: 'UNIQUE_CUSTOMER_ID'
};
/**
 * Enumerated type of vehicle sales discount scheme usage
 * @export
 * @enum {string}
 */
export const VehicleSalesDiscountSchemeType = {
    NoDiscount: 'NO_DISCOUNT',
    DiscountIdSpecified: 'DISCOUNT_ID_SPECIFIED',
    FleetSizeSpecified: 'FLEET_SIZE_SPECIFIED',
    FleetSizeCountSpecified: 'FLEET_SIZE_COUNT_SPECIFIED',
    PurchaseCooperativeSpecified: 'PURCHASE_COOPERATIVE_SPECIFIED',
    DiscountNotUsed: 'DISCOUNT_NOT_USED'
};
/**
 * Enumerated type of a vehicle type. See mapping logic https://git.daimler.com/dh-io-mmcs/commons-be/blob/master/mmc_connector_client/src/main/java/com/daimler/mymercedes/mmc/backend/connectors/datacontext/VehicleInfoDC.java
 * @export
 * @enum {string}
 */
export const VehicleTypeType = {
    ConnectVehicle: 'CONNECT_VEHICLE',
    HybridVehicle: 'HYBRID_VEHICLE',
    AdapterVehicle: 'ADAPTER_VEHICLE',
    None: 'NONE'
};
//# sourceMappingURL=api.js.map